import React from 'react'
import { withRouter } from 'react-router-dom'
import { Card } from '@myxplor/ui'

import GetISSCreds from './forms/getISSCreds'
import PostISSCreds from './forms/postISSCreds'

class ISSCredentialsUpdate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      serviceId: null,
      regHolder: null,
      existingCreds: null,
      newCreds: null
    }
    this.updateServiceId = this.updateServiceId.bind(this)
    this.updateExistingCreds = this.updateExistingCreds.bind(this)
    this.updateNewCreds = this.updateNewCreds.bind(this)
  }

  updateServiceId(serviceId) {
    this.setState(function(prevState) {
      return {
        ...prevState,
        serviceId: serviceId
      }})
  }

  updateExistingCreds(data) {
    this.setState(function(prevState) {
      return {
        ...prevState,
        regHolder: data.reg_holder,
        existingCreds: data.iss_creds
      }})
  }

  updateNewCreds(creds) {
    this.setState(function(prevState) {
      return {
        ...prevState,
        newCreds: creds
      }})
  }

  render() {
    const { serviceId, regHolder, existingCreds, newCreds } = this.state

    if (newCreds) {
      const { username, password, first_name, last_name, person_id } = newCreds.iss_creds

      return(
        <Card>
          <h2>ISS Credentials Updated</h2>

          <h2>{regHolder.name}</h2>
          <p><strong>CCMS Username:</strong> {username}</p>
          <p><strong>CCMS Password:</strong> {password}</p>
          <p><strong>Authorized Person First Name:</strong> {first_name}</p>
          <p><strong>Authorized Person Last Name:</strong> {last_name}</p>
          <p><strong>Authorized Person ID:</strong> {person_id}</p>
        </Card>
      )
    }

    if (regHolder) {
      return(
        <Card>
          <h2>Update ISS Credentials - {regHolder.name}</h2>

          <PostISSCreds
            serviceId={serviceId}
            updateNewCreds={this.updateNewCreds}
            defaultValues={existingCreds}
          />
        </Card>
      )
    }

    return(
      <Card>
        <h2>Update ISS Credentials</h2>

        <GetISSCreds
          updateExistingCreds={this.updateExistingCreds}
          updateServiceId={this.updateServiceId}
        />
      </Card>
    )
  }
}

export default withRouter(ISSCredentialsUpdate)



// WEBPACK FOOTER //
// ./src/iss-credentials-update/container.js